/* =================================================================== */
/* Mosaibul FIX: Mega Menu Auto Expend - Desktop Only         
/* Files: ms-custom-mega-menue.js | Theme.liquid | base.css
/* =================================================================== */

document.addEventListener('DOMContentLoaded', function() {

  function initHoverMegaMenu() {
    const megaMenus = document.querySelectorAll('header-menu details.mega-menu');
    let closeTimer;

    if (!megaMenus.length) {
      return; 
    }

    megaMenus.forEach(menu => {
      const summary = menu.querySelector('summary');

    
      menu.addEventListener('mouseenter', function() {
        clearTimeout(closeTimer);

        megaMenus.forEach(otherMenu => {
          if (otherMenu !== this) {
            otherMenu.removeAttribute('open');
          }
        });

        if (!this.hasAttribute('open')) {
          this.setAttribute('open', '');
        }
      });

      menu.addEventListener('mouseleave', function() {
        closeTimer = setTimeout(() => {
          this.removeAttribute('open');
        }, 200);
      });

      summary.addEventListener('click', function(event) {
        clearTimeout(closeTimer); 
      });
    });
  }

  const mediaQuery = window.matchMedia('(min-width: 990px)');

  function checkMediaQuery(e) {
    if (e.matches) {
      initHoverMegaMenu();
    }
  }

  checkMediaQuery(mediaQuery);

  mediaQuery.addEventListener('change', checkMediaQuery);
});